export enum DocumentActionType {
  FETCH_DOCUMENTS = 'FETCH_DOCUMENTS',
  FETCH_TESI_DOCUMENTS = 'FETCH_TESI_DOCUMENTS',
  FETCH_CABLOG_DOCUMENTS = 'FETCH_CABLOG_DOCUMENTS',
  FETCH_DOCUMENT_TYPES = 'FETCH_DOCUMENT_TYPES',
  FETCH_BULK_DOCUMENTS = 'FETCH_BULK_DOCUMENTS'
}
